import { useState, useRef } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFSwiper from '@/components/UI/EFSwiper';
import { productMap, LocaleTypes } from '@/config/whole-home-backup-power-solution';
import { createEFPic } from '@/utils/useEFPic';
import EfImg from 'elem/ui/ef-img';

const { EFPic } = createEFPic('/img/landingPage/product/');

export default function N(): JSX.Element {
    const { useLang, useRouter, Link } = useGlobal();
    const { t } = useLang('landingPage');
    const { locale } = useRouter();
    const swiperRef = useRef(null);
    const [showSwiperBtn, setShowSwiperBtn] = useState('right');
    const productList = productMap[locale as LocaleTypes] || [];

    return (
        <div className={`landing_page_N ${css.landing_page_N}`}>
            {showSwiperBtn === 'left' && (
                <div
                    className="btn btn-left"
                    onClick={() => {
                        setShowSwiperBtn('right');
                        swiperRef.current?.toRight();
                    }}
                >
                    <div className="icon"></div>
                </div>
            )}
            {showSwiperBtn === 'right' && (
                <div
                    className="btn btn-right"
                    onClick={() => {
                        setShowSwiperBtn('left');
                        swiperRef.current?.toLeft();
                    }}
                >
                    <div className="icon"></div>
                </div>
            )}
            <div className="viewport-wrapper">
                <div className="title">{t('secN_title')}</div>
                <EFSwiper spaceBetween={20} className="product-swiper" ref={swiperRef}>
                    {productList.map((product, index) => (
                        <div className="ef-swiper-slide" key={index}>
                            {String(product?.img)?.startsWith('https://') ? (
                                <EfImg pc={product.img} className="product-img" />
                            ) : (
                                <EFPic name={product.img} className="product-img" />
                            )}
                            <div className="name">{t(product.name)}</div>
                            {product?.link && (
                                <Link
                                    className="buy-btn"
                                    href={product?.link}
                                    target="blank"
                                    dataLayer={{
                                        event: 'uaEvent',
                                        event_name: 'buy',
                                        product_name: t(product?.name),
                                        position: `Solution Page_${t('secN_title')}`,
                                    }}
                                >
                                    {t('learn_more')}
                                </Link>
                            )}
                        </div>
                    ))}
                </EFSwiper>
            </div>
        </div>
    );
}
